
var formApp = angular.module('formApp', ['sharedServices','configService', 'sharedFilters', 'angular-loading-bar', 'ngCookies']);

formApp.config(function($interpolateProvider,$httpProvider,cfpLoadingBarProvider) {
    cfpLoadingBarProvider.includeSpinner = false;
    $interpolateProvider.startSymbol('{[');
    $interpolateProvider.endSymbol(']}');
    $httpProvider.interceptors.push('APIInterceptor');
});
formApp.controller('formController', function ($scope, $cookies, EncryptedLocalStorage, deviceRegister, loginAPI, config,vendorLogin,vendorDashboard, getUserInfo) {
    $scope.user = {};
    $scope.S3_URL = config.S3_URL;
    var logging_in = false;
    $('#loginModal').on('hidden.bs.modal', function (e) {
        $('#login_email_error').css('display', 'none');
        $('#login_password_error').css('display', 'none');
        $('#login_error_msg').css('display', 'none');
        $('#vlogin_email_error').css('display', 'none');
        $('#vlogin_password_error').css('display', 'none');
        $('#vlogin_error_msg').css('display', 'none');
        $('#vlogin_email_validity').css('display','none');
    });

    $scope.submitForm = function(credentials,type) {
        $('#login_email_error').css('display', 'none');
        $('#login_password_error').css('display', 'none');
        $('#login_error_msg').css('display', 'none');
        config.token = localStorage.getItem('token');
        config.vtoken = localStorage.getItem('vtoken');
        if(!logging_in) {
            logging_in = true;
        }
        if (localStorage.getItem('redux')) {
            var redux = JSON.parse(localStorage.getItem('redux'));
        }
        else {
            var redux = { login: {}, profile: {} };
        }
        if (type == 'user' && logging_in) {
            loginAPI(config.token, credentials.username, credentials.password).success(function(data) {
                logging_in = false;
                if (data.response.status) {
                    if(data.response.message === "Already logged In.") {
                        localStorage.setItem('logged_in', 'true');
                        redux['login']['loggedIn'] = true;
                        redux['login']['loginType'] = 'User';
                        redux['profile']['profileType'] = 'User';
                        /*$('#login_error_msg').css('display', 'block');
                        $('#login_error_msg').html('*'+data.response.message);
                        return;*/
                    }
                    if (data.response.message === "Invalid Token") {
                        $('#login_error_msg').css('display', 'block');
                        $('#login_error_msg').html('* Please try again');
                        return;
                    }
                    localStorage.setItem('logged_in', 'true');
                    redux['login']['loggedIn'] = true;
                    redux['login']['loginType'] = 'User';
                    redux['profile']['profileType'] = 'User';
                    localStorage.setItem('redux', JSON.stringify(redux));
                    getUserInfo(config.token).success(function(data) {
                        $scope.formAppUserInfo = data;
                        redux['profile']['myWedding'] = data.data.my_wedding;
                        redux['profile']['profile'] = data.data[0];
                        redux['profile']['userProperties'] = data.data.user_properties;
                        redux['profile']['weddings'] = data.data.weddings;
                        localStorage.setItem('redux', JSON.stringify(redux));
                        if( /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                            window.location.reload();
                            return;
                        }
                        if (!localStorage.getItem('wedding_id') || (typeof localStorage.getItem('wedding_id') == 'undefined') || localStorage.getItem('wedding_id') == 'null') {
                            if (window.location.pathname == '/' && (data.data.my_wedding || data.data.weddings[0].wedding_id)) {
                                window.location.href = config.domain + '/dashboard/profile/feeds/';
                            } else {
                                window.location.reload();
                            }
                        }
                    });
                    //window.location.href = 'http://localhost:8000/dashboard/profile/feeds#/';
                } else {
                    if (data.response.message === "user does not exist.") {
                        $('#login_password_error').css('display', 'none');
                        $('#login_email_error').css('display', 'block');
                    } else if (data.response.message === "Password is wrong") {
                        $('#login_email_error').css('display', 'none');
                        $('#login_password_error').css('display', 'block');
                    } else {
                        $('#login_password_error').css('display', 'none');
                        $('#login_email_error').css('display', 'none');
                        $('#login_error_msg').css('display', 'block');
                        $('#login_error_msg').html('*'+data.response.message);
                    }
                }
            });
        } else if(type == 'vendor' && logging_in) {
            $('#vlogin_email_error').css('display', 'none');
            $('#vlogin_password_error').css('display', 'none');
            $('#vlogin_error_msg').css('display', 'none');
            $('#vlogin_email_validity').css('display','none');
            if(!validateEmail(credentials.username)) {
                $('#vlogin_email_validity').css('display','block');
                return;
            }
            vendorLogin(credentials.username,credentials.password,config.vtoken).success(function(data) {
                logging_in = false;
                if (data.response.status) {
                  console.log(data);
                    if(data.response.message === "Already logged In.") {
                        localStorage.setItem('vendor_logged_in', 'true');
                        redux['login']['loggedIn'] = true;
                        redux['login']['loginType'] = 'Vendor';
                        redux['profile']['profileType'] = 'Vendor';
                        /*$('#vlogin_error_msg').css('display', 'block');
                        $('#vlogin_error_msg').html('*'+data.response.message);
                        return;*/
                    }
                    localStorage.setItem('vendor_logged_in', 'true');
                    redux['login']['loggedIn'] = true;
                    redux['login']['loginType'] = 'Vendor';
                    redux['profile']['profileType'] = 'Vendor';
                    localStorage.setItem('redux', JSON.stringify(redux));
                    if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                        window.location.href = config.domain + '/vendor-mobile';
                        return;
                    }
                    vendorDashboard(config.vtoken).success(function(data){
                        redux['profile']['profile'] = data.data;
                        localStorage.setItem('redux', JSON.stringify(redux));
                        if (data.data.status === 'N') {
                            window.location.href = config.domain + '/vendor/feeds/';
                        } else if (data.data.status === 'Y' || data.data.role[0] == 'ROLE_BRAND_VENDOR') {
                            window.location.href = config.domain + '/vendor/feeds/leads?id='+JSON.parse(localStorage.redux).profile.profile.vendor_id;
                        } else {
                             window.location.href = config.domain + '/vendor/feeds/';
                        }
                    })
                } else {
                    if (data.response.message === "vendor does not exist.") {
                        $('#vlogin_password_error').css('display', 'none');
                        $('#vlogin_email_error').css('display', 'block');
                    } else if (data.response.message === "Password is wrong") {
                        $('#vlogin_email_error').css('display', 'none');
                        $('#vlogin_password_error').css('display', 'block');
                    } else {
                        $('#vlogin_password_error').css('display', 'none');
                        $('#vlogin_email_error').css('display', 'none');
                        $('#vlogin_error_msg').css('display', 'block');
                        $('#vlogin_error_msg').html('*'+data.response.message);
                    }
                }
            })
        }
    }
    var os = [{
        name: 'Windows Phone',
        value: 'Windows Phone',
        version: 'OS'
    }, {
        name: 'Windows',
        value: 'Win',
        version: 'NT'
    }, {
        name: 'iPhone',
        value: 'iPhone',
        version: 'OS'
    }, {
        name: 'iPad',
        value: 'iPad',
        version: 'OS'
    }, {
        name: 'Kindle',
        value: 'Silk',
        version: 'Silk'
    }, {
        name: 'Android',
        value: 'Android',
        version: 'Android'
    }, {
        name: 'PlayBook',
        value: 'PlayBook',
        version: 'OS'
    }, {
        name: 'BlackBerry',
        value: 'BlackBerry',
        version: '/'
    }, {
        name: 'Macintosh',
        value: 'Mac',
        version: 'OS X'
    }, {
        name: 'Linux',
        value: 'Linux',
        version: 'rv'
    }];
    var header = [
        navigator.platform,
        navigator.userAgent,
        navigator.appVersion,
        navigator.vendor,
        window.opera
    ];
    // function to check os name and version
    function matchItem(string, data) {
        var i = 0,
            j = 0,
            html = '',
            regex,
            regexv,
            match,
            matches,
            version;
        for (i = 0; i < data.length; i += 1) {
            regex = new RegExp(data[i].value, 'i');
            match = regex.test(string);
            if (match) {
                regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
                matches = string.match(regexv);
                version = '';
                if (matches) {
                    if (matches[1]) {
                        matches = matches[1];
                    }
                }
                if (matches) {
                    matches = matches.split(/[._]+/);
                    for (j = 0; j < matches.length; j += 1) {
                        if (j === 0) {
                            version += matches[j] + '.';
                        } else {
                            version += matches[j];
                        }
                    }
                } else {
                    version = '0';
                }
                return {
                    name: data[i].name,
                    version: parseFloat(version)
                };
            }
        }
        return {
            name: 'unknown',
            version: 0
        };
    }
    var agent = header.join(' ');
    var os = matchItem(agent, os);
    var resolution = screen.width + '*' + screen.height;
    if (!localStorage.getItem('token')){
        deviceRegister(os.name, '1', resolution + '|' + navigator.userAgent).success(function(data) {
            var token = data.data.token;
            localStorage.setItem('token', token);
            $cookies.put('token', token, { 'path' : '/'});
            config.token = localStorage.getItem('token');
            localStorage.setItem('deviceDataUpdated', true)
        })
    } else {
        $('#navApp').trigger('sendIfnoToken',[config.token])
    }

    if (!localStorage.getItem('vtoken')) {
        deviceRegister(os.name, '1', resolution + '|' + navigator.userAgent).success(function(data) {
            var token = data.data.token;
            localStorage.setItem('vtoken', token);
            $cookies.put('vtoken', token, { 'path': '/' });
            config.vtoken = localStorage.getItem('vtoken');
            localStorage.setItem('deviceDataUpdated', true)
        })
    }
    if(localStorage.getItem('logged_in')) {
        if (localStorage.getItem('redux')) {
            var redux = JSON.parse(localStorage.getItem('redux'));
        }
        else {
            var redux = { login: {}, profile: {} };
        }
        redux['login']['loggedIn'] = true;
        redux['login']['loginType'] = 'User';
        redux['profile']['profileType'] = 'User';
        localStorage.setItem('redux', JSON.stringify(redux));
        getUserInfo(config.token || localStorage.getItem('token')).then(function (data) {
            redux['profile']['myWedding'] = data.data.data.my_wedding;
            redux['profile']['profile'] = data.data.data[0];
            redux['profile']['userProperties'] = data.data.data.user_properties;
            redux['profile']['weddings'] = data.data.data.weddings;
            localStorage.setItem('redux', JSON.stringify(redux));
        });
    }
    if(localStorage.getItem('vendor_logged_in')) {
        if (localStorage.getItem('redux')) {
            var redux = JSON.parse(localStorage.getItem('redux'));
        }
        else {
            var redux = { login: {}, profile: {} };
        }
        redux['login']['loggedIn'] = true;
        redux['login']['loginType'] = 'Vendor';
        redux['profile']['profileType'] = 'Vendor';
        localStorage.setItem('redux', JSON.stringify(redux));
        vendorDashboard(localStorage.vtoken).success(function (data) {
            redux['profile']['profile'] = data.data;
            localStorage.setItem('redux', JSON.stringify(redux));
        });
    }

})
angular.bootstrap(document.getElementById("loginModal"), ['formApp']);
